// Scroll target for the hero's "details and comments" caret cue → the below-the-fold section
// (mirrors audio-web AUDIO_DETAILS_ELEMENT_ID).
export const AUDIO_DETAILS_ANCHOR = 'audio-details'
